import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {securityRoutes} from '@features/security/security.route';
import {CommandService} from '@core/services/command.service';
import {SecurityDynamicComponentHelper} from '@features/security/security-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformToolSecurityHandler} from '@features/security/services/platform-tool-security-handler';
import {SharedModule} from '@shared/shared.module';
import { UserRolesCellViewerComponent } from './components/user-roles-cell-viewer/user-roles-cell-viewer.component';
import { ManageUserRolesComponent } from './components/manage-user-roles/manage-user-roles.component';
import { ManageRoleUsersComponent } from './components/manage-role-users/manage-role-users.component';
import { RolesAndUsersComponent } from './components/roles-and-users/roles-and-users.component';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {ChangeReportApiDataProvider} from '@features/change-report/change-report-api-data-provider';
import {SecurityApiDataProvider} from '@features/security/services/security-api-provider';
import {
  rolesAndUsersValidator,
  ValidatorHelper
} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/validators-model';
import { UsersAndRolesWithAccessComponent } from './components/users-and-roles-with-access/users-and-roles-with-access.component';

@NgModule({
  declarations: [
    UserRolesCellViewerComponent,
    ManageUserRolesComponent,
    ManageRoleUsersComponent,
    RolesAndUsersComponent,
    UsersAndRolesWithAccessComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(securityRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SecurityModule {

  constructor(
    private platformApiProvider: PlatformApiProvider,
    private commandService: CommandService,
              private platformToolSecurityHandler: PlatformToolSecurityHandler) {

    SecurityDynamicComponentHelper.init();

    SecurityDynamicComponentHelper.register('PlatformToolSecurityHandler', platformToolSecurityHandler);
    this.platformApiProvider.registerAtTop(new SecurityApiDataProvider());
    this.commandService.registrPlatformLinkCommand('/users', new PlatformCommand('ManageUsersToolLinkCommand', Api.Security));
    this.commandService.registrPlatformLinkCommand('/users/manage-request', new PlatformCommand('ManageUserRequestAccessCommand', Api.Security));
    ValidatorHelper.registerValidator(rolesAndUsersValidator);
  }
}
